import { Platform, StyleSheet } from 'react-native';

import {
    heightPercentageToDP,
    widthPercentageToDP,
} from 'utils/responsiveness';

const gStyles = StyleSheet.create({
    container: {
        flex: 1,
    },
    flexZero: { width: 0, height: 0 },
    flex: {
        flex: 1,
    },
    flexWithBottomPadding: {
        flex: 1,
        paddingBottom: 25,
    },
    centerItems: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    flexRow: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    flexRowSpace: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    settingsContainer: {
        paddingTop: Platform.select({
            web: 0,
            default: heightPercentageToDP(40),
        }),
        flex: 1,
        alignItems: Platform.select({
            web: 'center',
            default: 'stretch',
        }),
    },
    settingsContentContainer: {
        paddingHorizontal: widthPercentageToDP(16, 160),
        // @ts-ignore
        width: Platform.select({ web: 688, default: 'auto' }),
        marginBottom: Platform.select({ web: 40, default: undefined }),
    },
    containerDefaultPadding: {
        paddingHorizontal: 16,
    },
    rootHeaderDefaultPaddingLeft: {
        paddingLeft: widthPercentageToDP(16, 44, 72),
    },
    headerDefaultPaddingLeft: {
        paddingLeft: widthPercentageToDP(12, 40),
    },
    headerDefaultPaddingRight: {
        paddingRight: widthPercentageToDP(16, 44, 72),
    },
    headerContainer: {
        justifyContent: 'center',
    },
    svgButtonMarginRight: {
        marginRight: 5,
    },
});

export default gStyles;
